import React from 'react'
import PropTypes from 'prop-types'
import IndividualResourceV3Component from 'pages/IndividualResourceV3/component'

import { transformLegacyEntryForV2_5View } from './helpers'

const IndividualResourceV2_5Component = ({ entry, ...rest }) => {
  const transformedEntry = transformLegacyEntryForV2_5View({ entry })

  if (!transformedEntry) {
    return null
  }

  return <IndividualResourceV3Component entry={transformedEntry} {...rest} />
}

IndividualResourceV2_5Component.propTypes = {
  entry: PropTypes.object,
}

export default IndividualResourceV2_5Component
